import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=8119ce66&scoped=true&"
import script from "@/views/Users/Guardian/CreateDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Guardian/CreateDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Guardian/create-dialog.scss?vue&type=style&index=0&id=8119ce66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8119ce66",
  null
  
)

export default component.exports